import {useStyles} from "./SelectControl.styles";


type Props<T extends string|number> = {
    options: {  value: T, label: string }[]
    value: T
    onChange: (value: T) => void
    className?: string
}

const SelectControl = <T extends string|number>(
    {
        options,
        value,
        onChange,
        className = "",
    }: Props<T>
) => {
    const styles = useStyles();
    return (
        <div className={`${styles.component} ${className} alignwide`}>
            <select
                value={value}
                onChange={e => onChange(e.target.value as T)}
                className={styles.select}
            >
                {options.map(({value, label})=> <option key={value} value={value}>{label}</option>)}
            </select>
        </div>
    )
}

export default SelectControl;